import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/staked-frame.gif'
import _imports_1 from '../../assets/unstaked-frame.gif'


const _withScopeId = n => (_pushScopeId("data-v-65ec0c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { className: "w-full md:w-1/2 lg:w-1/3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "staked bohemian"
}, null, -1))
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "absolute bottom-[38px] left-[80px] w-[220px] text-center" }
const _hoisted_5 = { class: "text-ld mb-[-2px]" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-md" }, "dsds", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "staked bohemian"
}, null, -1))
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  class: "absolute",
  style: {"top":"296px","left":"83px","bottom":"150px","width":"203px"}
}
const _hoisted_10 = { class: "text-ld mb-[-2px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.stake === 'true')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "relative inline-block cursor-pointer",
          style: {"width":"460px","height":"460px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unstakeNFT()))
        }, [
          _hoisted_2,
          _createElementVNode("img", {
            class: "absolute",
            style: {"top":"84px","left":"120px","width":"215px"},
            src: _ctx.nft.externalMetadata.image,
            alt: _ctx.nft.onchainMetadata.data.name
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.nft.onchainMetadata.data.name), 1),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.stake === 'false')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "relative inline-block cursor-pointer",
          style: {"width":"460px","height":"460px"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unstakeNFT()))
        }, [
          _hoisted_7,
          _createElementVNode("img", {
            class: "absolute bottom-[150px] left-[65px] w-[220px] text-center",
            style: {"top":"22px","left":"46px","bottom":"150px","width":"203px"},
            src: _ctx.nft.externalMetadata.image,
            alt: _ctx.nft.onchainMetadata.data.name
          }, null, 8, _hoisted_8),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.nft.onchainMetadata.data.name), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}